var DEFAULT_VISIBLE_OPTIONS = 5;

export { DEFAULT_VISIBLE_OPTIONS };
